import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import { AppSettingsService } from 'src/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';
import { UserDialogComponent } from '../admin/components/user-dialog/user-dialog.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-access',
    templateUrl: './access.component.html',
    styleUrls: ['./access.component.scss'],
    standalone: true
})
export class AccessComponent {
  private appSettings: AppSettings = new AppSettings();
  private dialogSubscription: Subscription | null = null

  public title: string = '';
  public type: string = 'application';
  public supportLink: string = '';

  constructor(
    private appSettingsService: AppSettingsService,
    private router: Router,
    private dialog: MatDialog
  ) {}

  // Initializes component and loads app settings
  public async ngOnInit(): Promise<void> {
    if (window.history.state.type && window.history.state.type !== '') {
      this.type = window.history.state.type;
    }

    this.appSettings = await this.appSettingsService.getSettings();
    this.title = this.appSettings.title;
    this.supportLink = this.appSettings.supportLink;
  }

  // Opens user dialog when access is not granted
  public goToDialog(): void {
    const dialogRef = this.dialog.open(UserDialogComponent, {
      width: '400px',
      data: { no_access: true }
    });

   this.dialogSubscription = (  dialogRef.afterClosed().subscribe(result => {
    })
    )
  }

  
public ngOnDestroy(): void {
  if (this.dialogSubscription) {
    this.dialogSubscription.unsubscribe();
    this.dialogSubscription = null;
  }
}

}
